import { createContext } from 'react';

const AnimationContext = /*#__PURE__*/createContext({
  isDraggable: false,
  setActiveRect: null
});

export { AnimationContext };
